import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

import {
  DENTAL_PHOTOS_FILTER_FAMILY,
  REPORT_FILTER_FAMILIES,
  REPORT_FILTER_FAMILY_KEYS,
  ReportFilterFamilyKey,
} from '../config';

export const isReportFilterFamilyKey = (
  value: string,
): value is ReportFilterFamilyKey =>
  (REPORT_FILTER_FAMILY_KEYS as readonly string[]).includes(value);

export const normalizeReportFilterFamilies = (
  values: readonly string[],
): ReportFilterFamilyKey[] =>
  REPORT_FILTER_FAMILY_KEYS.filter((key) => values.includes(key));

export const expandReportFilterFamilies = (
  values: readonly string[],
): ReportType[] =>
  Array.from(
    new Set(
      normalizeReportFilterFamilies(values).flatMap(
        (key) => REPORT_FILTER_FAMILIES[key],
      ),
    ),
  );

/**
 * `OnlyStudyTypes` matches patients with at least one of the listed types, so
 * the dental photos family widens the study filter (Studies → Pano + Reports →
 * Dental Photos lists patients with a pano OR a photo) rather than narrowing it.
 */
export const withDentalPhotosStudyType = (
  studyTypes: readonly StudyType[],
  reportFamilies: readonly string[],
): StudyType[] =>
  reportFamilies.includes(DENTAL_PHOTOS_FILTER_FAMILY)
    ? Array.from(new Set([...studyTypes, StudyType.StudyType_DentalPhoto]))
    : [...studyTypes];

export const parseReportTypesParam = (
  param: string | null | undefined,
): ReportFilterFamilyKey[] =>
  param ? normalizeReportFilterFamilies(param.split(',')) : [];
